import SKnowledgeBase from "./SKnowledgeBase_web"
export default SKnowledgeBase
